import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchTypeService = () => {
  return new ServicesUseCase('/service/typeServices', makeAxiosHttpClient())
}
